export const DOCUMENT_SECTIONS = [
  "SHIPPING DOCUMENTS",
  "PERMIT & LICENSES",
  "CUSTOMS FORMALITIES",
  "SHIPPINGLINE FORMALITIES & DELIVERY",
];
